module.exports = __webpack_public_path__ + "static/media/Tic-Tac-Toe.811601fc.png";